<template>
  <div class="page-frame">
    <el-tabs class="page-tabs" :class="'default' === layout ? '' : ' invisible-tab'"
             style="box-shadow: 0 2px 4px 0 rgba(222, 227, 236, 0.80) inset !important;"
             v-model="tabsActiveName" type="card" @tab-remove="tabsRemove" @tab-click="tabsClick">
      <el-tab-pane v-for="(item, index) in tabsList" :key="item.name" :name="item.name" :closable="index !== 0"
                   :lazy="true">
        <span slot="label">
          {{ item.title }}
        </span>
        <div class="iframe-container" v-loading="item.loading" element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0)">
          <iframe class="zwx-iframe" ref="zwxIframe" :src="item.content" frameborder="0"
                  :onload="iframeOnload(item, index)"/>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'PageFrame',
  props: ['layout'],
  data() {
    return {
      tabsActiveName: '',
      tabsList: [],
      ifTabsChange: true,
    }
  },
  created() {

  },
  watch: {
    tabsList() {
      this.ifTabsChange = true
    },
  },
  mounted() {
    this.tabsListen()
  },
  computed: {},
  methods: {
    tabsListen() {
      const pageTabsList = document.getElementsByClassName('page-tabs')
      if (pageTabsList === undefined || pageTabsList === null || pageTabsList.length === 0) return
      this.$zwxBases.listenDocumentWH(pageTabsList[0].getElementsByClassName('el-tabs__nav'), this.tabsCallback)
    },
    tabsCallback() {
      if (!this.ifTabsChange) return
      this.ifTabsChange = false
      const pageTabsList = document.getElementsByClassName('page-tabs')
      if (pageTabsList === undefined || pageTabsList === null || pageTabsList.length === 0) return
      const elTabsItem = pageTabsList[0].getElementsByClassName('el-tabs__item')
      for (let i = 0, length = elTabsItem.length; i < length; i++) {
        elTabsItem[i].onmouseup = event => this.mouseup(event, this.tabsList[i].name)
      }
    },
    mouseup(event, name) {
      if (event.which !== 2 || this.tabsList[0].name === name) return
      this.tabsRemove(name)
    },
    tabsRemove(name) {
      let activeName = this.tabsActiveName
      let index = -1
      for (let i = 0, length = this.tabsList.length; i < length; i++) {
        if (this.tabsList[i].name === name) {
          activeName = this.tabsRemoveActive(name, activeName, i, length)
          index = i
          break
        }
      }
      if (index === -1) return
      this.tabsActiveName = activeName
      this.$emit('tabSelect', activeName)
      this.tabsList.splice(index, 1)
    },
    tabsRemoveActive(name, activeName, i, length) {
      if (activeName === name) {
        if (length > 1) {
          activeName = this.tabsList[i < length - 1 ? i + 1 : i - 1].name
        } else {
          activeName = 'home'
        }
      }
      return activeName
    },
    tabsClick(tab) {
      this.$emit('tabSelect', tab.name)
    },
    menuTabs(name, title, content, refresh) {
      let index = -1
      for (let i = 0, length = this.tabsList.length; i < length; i++) {
        if (this.tabsList[i].name === name) {
          index = i
          break
        }
      }
      if (index === -1) {
        this.tabsList.push({name: name, title: title, content: content, loading: true})
      } else if (this.tabsActiveName === name || refresh) {
        this.tabsList[index].loading = true
        this.$refs.zwxIframe[index].src = content
        this.$refs.zwxIframe[index].contentWindow.location.reload(true)
      }
      this.tabsActiveName = name
    },
    iframeOnload(item, index) {
      if (!item.loading) return
      this.$nextTick(() => this.iframeOnloadNextTick(item, index))
    },
    iframeOnloadNextTick(item, index) {
      let iframe = this.$refs.zwxIframe[index]
      if (iframe.attachEvent) {
        this.iframeOnloadAttachEvent(item, iframe)
        return
      }
      iframe.onload = () => {
        item.loading = false
      }
    },
    iframeOnloadAttachEvent(item, iframe) {
      iframe.attachEvent('onload', () => {
        item.loading = false
      })
    },
  },
}
</script>

<style lang="less" >
.page-frame {
  position: relative;
  width: 100%;
  height: 100%;

  .iframe-container {
    position: absolute;
    margin: 0 12px 10px 12px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #ffffff;
    border-radius: 0 0 2px 2px !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04) !important;


    .zwx-iframe {
      position: relative;
      width: 100%;
      height: 100%;
      border-width: 0;
      display: block;
    }
  }

  .invisible-tab, .main-head-tabs {
    box-shadow: 0 2px 4px 0 rgba(222, 227, 236, 0.80) inset !important;
  }

  .invisible-tab .el-tabs__header {
    display: none !important;
  }

  .invisible-tab .el-tabs__content {
    top: 0 !important;
  }

  .invisible-tab .iframe-container {
    margin-top: 10px !important;
  }

  .page-tabs {
    position: absolute;
    width: 100%;
    min-width: 100px;
    top: 0;
    bottom: 0;
    background-color: #EEF2FB !important;

    .el-tab-pane {
      height: 100%;
    }

    .el-icon-s-home {
      font-size: 14px;
      color: #464749;
      margin-right: 5px;
    }

    .el-tabs__header {
      margin: 0 !important;
      top: 10px !important;
      padding: 0 12px !important;
      border-bottom: none !important;
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }

    .el-tabs__nav {
      border-color: transparent !important;
      border-bottom: none !important;
    }

    .el-tabs__nav-wrap {
      margin-left: 18px !important;
      margin-right: 18px !important;
    }

    .el-tabs__nav-wrap.is-scrollable {
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding: 0 22px !important;
    }

    .el-tabs__nav-prev {
      border-radius: 4px 0 0 0;
    }

    .el-tabs__nav-next {
      border-radius: 0 4px 0 0;
    }

    .el-tabs__nav-prev,
    .el-tabs__nav-next {
      width: 18px !important;
      height: 34px !important;
      line-height: 34px !important;
      top: 1px !important;
      text-align: center !important;
      font-size: 15px !important;
      color: #464749 !important;
      background-color: #ffffff !important;
      border: 1px solid #d5d9e0 !important;
      margin: 0 !important;
      -webkit-box-shadow: 0 -1px 5px 0 #dcdddf !important;
      -moz-box-shadow: 0 -1px 5px 0 #dcdddf !important;
      box-shadow: 0 -1px 5px 0 #dcdddf !important;
    }

    .el-tabs__nav-prev:hover,
    .el-tabs__nav-next:hover {
      background: linear-gradient(180deg, #ffffff, #eeeeee);
      border-radius: 2px !important;
    }

    .el-tabs__nav-prev .el-icon-arrow-left,
    .el-tabs__nav-next .el-icon-arrow-right {
      vertical-align: middle !important;
    }

    .el-tabs__nav-prev .el-icon-arrow-left:before {
      content: '\e792' !important;
    }

    .el-tabs__nav-next .el-icon-arrow-right:before {
      content: '\e791' !important;
    }

    .el-tabs__item {
      height: 34px !important;
      line-height: 34px !important;
      padding: 0 12px !important;
      margin: 0 2px !important;
      color: #1f2d3d !important;
      font-size: 14px !important;
      font-weight: normal !important;
      border: 1px solid #d5d9e0 !important;
      border-bottom: none !important;
      border-radius: 4px 4px 0 0 !important;
      outline: none !important;
      box-sizing: border-box !important;
      background-color: #f5f7fa !important;
      position: relative;
    }

    .el-tabs__item.is-closable:focus,
    .el-tabs__item.is-closable:hover {
      color: black !important;
    }

    .el-tabs__item:hover {
      background: #eaf3ff !important;
      color: #1F2D3D !important;
    }

    .el-tabs__item.is-active,
    .el-tabs__item.is-active:focus,
    .el-tabs__item.is-active:hover {
      color: #4969D9 !important;
      background-color: white !important;
    }

    .el-tabs__item .el-icon-close {
      color: #1f2d3d !important;
      line-height: 15px !important;
      font-weight: bold !important;
      font-size: 8px !important;
    }

    .el-tabs__item .el-icon-close:focus,
    .el-tabs__item .el-icon-close:hover {
      background-color: transparent !important;
    }

    .el-tabs__item.is-active.is-closable {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }

    .el-tabs__content {
      position: absolute !important;
      width: 100% !important;
      top: 46px !important;
      bottom: 0 !important;
    }
  }
}
</style>
